<template>
    <v-layout row wrap>
        <v-flex xs12 md8>
            <v-text-field
                class="ucFirst body-2"
                :aria-label="formattedAriaLabel(
                    metadata[`description${this.upperLocale}`],
                    required
                )"
                :label="formattedLabel(
                    metadata[`description${this.upperLocale}`],
                    required || isRequiredByOtherMetadata
                )"
                :outlined="outlined"
                :append-icon="appendIcon"
                :value="value"
                :name="metadata.name"
                :color="$vuetify.theme.primary"
                :background-color="$vuetify.theme.primary"
                :placeholder="placeholder"
                validate-on-blur
                :maxlength="maxLength"
                :rules="[
                    !isRequired || requiredField(),
                    v => !v || getFormRule('telephone2')(v)
                ]"
                data-testid="phone-input"
                autocomplete="null"
                :data-meta-id="metadata.id"
                v-mask="$t('base.phoneMask')"
                :id="metadata.name"
                @input="debouncedInput"
            />
        </v-flex>
        <phone-extension
            :other-metadata="otherMetadata"
            :with-icon="withIcon"
            :outline="outlined"
            @updateOtherMetadata="$emit('updateOtherMetadata', $event)"
        />
    </v-layout>
</template>

<script>
import { inputHelpers } from '@/mixins/inputHelpers';
import { mapGetters } from 'vuex';
import { formRules } from '@/mixins/form-rules';
import { debounce, find, get } from 'lodash';
import { maskPhoneNumber } from '@/utils';
import { MetadataEnum } from '@/enums';
import PhoneExtension from '@/components/metadata/inputs/phone/PhoneExtension';

export default {
    name: 'phone',
    mixins: [formRules, inputHelpers],
    components: {
        PhoneExtension,
    },
    props: {
        metadata: { type: Object, required: true },
        otherMetadata: { type: Array, required: true },
        outlined: { type: Boolean, required: false, default: true },
        required: { type: Boolean, required: false, default: false },
        value: { type: String, required: false, default: '' },
        withIcon: { type: Boolean, required: false, default: false },
        placeholder: { type: String, required: false, default: '' },
    },
    data() {
        return {
            debouncedInput: undefined,
        };
    },
    created() {
        this.debouncedInput = debounce(this.emitValue, 100);
    },
    computed: {
        ...mapGetters({
            upperLocale: 'upperLocale',
        }),
        appendIcon() {
            return this.withIcon ? 'fas fa-phone' : '';
        },
        covidScreeningPreferredCommunicationByPhoneMetadata() {
            return this.otherMetadata &&
                find(this.otherMetadata, ['metadata', MetadataEnum.COVID_SCREENING_PREFERRED_COMMUNICATION]);
        },
        isRequiredByOtherMetadata() {
            const preferredCommunication = get(this.covidScreeningPreferredCommunicationByPhoneMetadata, 'value');
            const preferredCommunicationOptions = this.$i18n.t('covidScreeningMetadataLang.covidScreeningPreferredCommunication.dropDown');
            return preferredCommunication === preferredCommunicationOptions[1];
        },
        isRequired() {
            return this.required || this.isRequiredByOtherMetadata;
        },
        maxLength() {
            return this.metadata && this.metadata.rules && this.metadata.rules.maxLength;
        },
    },
    methods: {
        emitValue(value) {
            this.$emit('update:value', maskPhoneNumber(value));
        },
    },
};
</script>
